import { OnInit, EventEmitter, ElementRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ConversationService } from '../services/conversation.service';
import { WorkspaceService } from '../services/workspace.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material';
var KhamisComponent = /** @class */ (function () {
    function KhamisComponent(workspaceService, conversationService, router) {
        this.workspaceService = workspaceService;
        this.conversationService = conversationService;
        this.router = router;
        this.searchChanged = new EventEmitter();
        this.searchResultId = new EventEmitter();
        this.hasUpdate = false;
        this.isBusy = false;
        this.isSearching = false;
        this.searchTextChanged = new Subject();
        this.suggestions = [];
    }
    KhamisComponent.prototype.ngOnInit = function () {
        // this.input.nativeElement.focus(); // autofocus
        this.getSuggestions();
    };
    KhamisComponent.prototype.ngOnDestroy = function () {
        if (this.subs)
            this.subs.unsubscribe();
    };
    KhamisComponent.prototype.searchGlobal = function (value) {
        var _this = this;
        // this.workspaceService.searchEPICs(value).subscribe(result=>{
        //   this.searchResultId.emit(result);
        //   this.hasUpdate = !this.hasUpdate;
        //   this.searchChanged.emit(this.hasUpdate);
        // });
        this.isBusy = true;
        if (value) {
            this.conversationService.converse(value).subscribe(function (result) {
                var resultObject = JSON.parse(result);
                _this.isBusy = false;
                if (resultObject.ReturnType == "0") {
                    if (resultObject.Arguments) {
                        var path = [];
                        resultObject.Arguments.forEach(function (element) {
                            path.push(element);
                        });
                        ;
                        _this.router.navigate(path);
                    }
                }
            }, function (error) {
                _this.isBusy = false;
            });
        }
        else {
            this.isBusy = false;
        }
    };
    KhamisComponent.prototype.onValueChange = function (keyword) {
        this.searchTextChanged.next(keyword);
    };
    KhamisComponent.prototype.getSuggestions = function () {
        var _this = this;
        this.subs = this.searchTextChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe(function (value) {
            _this.isSearching = true;
            _this.conversationService.getSuggestions(_this.searchType, value).subscribe(function (result) {
                if (result) {
                    _this.suggestions = JSON.parse(result);
                }
                _this.isSearching = false;
            }, function (error) {
                _this.isSearching = false;
            });
        });
    };
    KhamisComponent.prototype.mouseEnter = function (word) {
        this.input.nativeElement.value = word;
    };
    KhamisComponent.prototype.mouseLeave = function () {
        this.input.nativeElement.value = "";
    };
    return KhamisComponent;
}());
export { KhamisComponent };
